import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ProductSelectionMode, UNLIMITED_PRODUCT_SELECTION, type ProductSelectionContext } from '../../product';
import type { Product } from '../../../types/product';

interface UseCatalogEditorNavigationParams {
  companyId: number;
  onProductsSelected: (products: Product[]) => void;
}

export function useCatalogEditorNavigation({ companyId, onProductsSelected }: UseCatalogEditorNavigationParams) {
  const navigate = useNavigate();
  const location = useLocation();

  // Handle return from the product picker (reused from Activity's MULTIPLE_PRODUCT_SELECTION flow,
  // which hands selected products back under location.state.activityFilters.products)
  useEffect(() => {
    const selectedProducts = location.state?.activityFilters?.products as Product[] | undefined;

    if (selectedProducts && selectedProducts.length > 0) {
      onProductsSelected(selectedProducts);
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const handleOpenProductPicker = () => {
    const context: ProductSelectionContext = {
      mode: ProductSelectionMode.MULTIPLE_PRODUCT_SELECTION,
      returnPath: location.pathname,
      maxSelection: UNLIMITED_PRODUCT_SELECTION,
      showSelectAll: true,
      infoText: 'Виберіть товари для каталогу. Ціну для кожного товару вкажете на наступному кроці.',
    };
    navigate(`/companies/${companyId}/products`, { state: context });
  };

  return {
    actions: {
      handleOpenProductPicker,
    },
  };
}
